'use client';

export { default, createFilterOptions } from './Autocomplete';
export { default as autocompleteClasses } from './autocompleteClasses';
export * from './autocompleteClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Autocomplete/index.js
// module id = 797
// module chunks = 22